import config from './config';

// Get the base URL for the current environment
export const getBaseUrl = () => {
  return config.getApiBaseUrl();
};

// Export the API configuration
export default {
  baseURL: getBaseUrl(),
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  }
}; 